import { NavLink } from "react-router-dom";
import Burger from "../assets/svgs/burger";
import { useState } from "react";

export const Header = () => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleMobileNav = () => {
        setIsNavOpen((prev) => {
            if (!prev === true) {
                document.body.style.overflow = "hidden";
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            else {
                document.body.style.overflow = "visible";
            }
            return !prev;
        });
    };
    return <>
        <section className="header full main-layout">
            <section className="nav flex space-between">
                <NavLink to={'/'}><section className="logo flex"></section></NavLink>
                <section className="navigation flex space-between">
                    <NavLink to={'/about'}>אודות</NavLink>
                    <NavLink to={'/menu'}>תפריט</NavLink>
                    <NavLink to={'/contact-us'}>צור קשר</NavLink>
                </section>
                <a target="_blanc" href="tel:972528011016" className="call-btn flex ">חייג עכשיו</a>
            </section>
            <div onClick={toggleMobileNav} className="burger-container">
                <Burger />
            </div>
        </section>
        {isNavOpen &&
            <section onClick={toggleMobileNav} className="mobile-nav flex column">
                <NavLink to={'/'}>דף הבית</NavLink>
                <NavLink to={'/about'}>אודות</NavLink>
                <NavLink to={'/menu'}>תפריט</NavLink>
                <NavLink to={'/contact-us'}>צור קשר</NavLink>
            </section>
        }
    </>;
};